<template>
    <!--VideoPlay.vue播放列表（下）-->
  <dd class="list">
    <a v-for="(item, index) in videoList" :key="index" @click="playVideo(item.video_id, item.status)" :alt="item.channel_vid" :class="current_video_id === item.video_id ? 'playing' : ''">
      <div class="left" v-if="item.status === 2">
        <h6>{{index + 1}} | {{item.name}}</h6>
        <div class="progress">
          <div class="bar"><i :style="{ width: + item.percentage + '%' }"></i></div>
          <span>观看{{item.percentage}}%</span>
        </div>
      </div>
      <div class="left" v-else>
        <h6 style="color: #292929;">{{index + 1}} | {{item.name}}</h6>
        <div class="livetime">
          <span>直播时间：{{item.date_start}}</span>
        </div>
      </div>
      <div class="right" v-if="item.status === 2">
        <img src="../../assets/icon/videoplay_icon_pause.png" :alt="course_id + '-' + item.video_id" v-if="current_video_id === item.video_id" style="visibility: hidden">
        <img src="../../assets/icon/videoplay_icon_play.png" :alt="course_id + '-' + item.video_id" v-else>
        <i v-if="current_video_id === item.video_id">播放中</i>
        <i v-else>播放</i>
      </div>
      <div class="right" v-else>
        <img src="../../assets/icon/videoplay_icon_pause.png" :alt="course_id + '-' + item.video_id" v-if="item.status === 3">
        <img src="../../assets/icon/videoplay_icon_play.png" :alt="course_id + '-' + item.video_id" v-else style="opacity: .3">
        <i v-if="item.status === 3">直播中</i>
        <i v-else style="opacity: .3;color: #292929;">未开始</i>
      </div>
      <span class="studied" v-show="item.percentage > 0">已学习</span>
    </a>
  </dd>
</template>

<script>
export default {
  name: 'VideoPlayList',
  data () {
    return {
      videoList: {}
    }
  },
  props: [
    'class_id',
    'course_id',
    'current_video_id'
  ],
  mounted () {
    this.getVideoList()
  },
  methods: {
    getVideoList () {
      let data = {
        class_id: this.class_id,
        course_id: this.course_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_live_first_timetable',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.videoList = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    playVideo (videoId, status) {
      if (status === 3) {
        this.$router.push({name: 'LivePlayer', query: {video_id: videoId}})
      } else if (status === 1) {
        event.preventDefault()
        return false
      }
      this.$emit('listenVid', this.course_id, videoId)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/play/VideoPlayList.vue